import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Subject } from 'rxjs/internal/Subject';
import { Observable } from 'rxjs/internal/Observable';

import { MAIN_DOMAIN } from '@app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class AbsentService {
    public addedToAbsent = new Subject<number>();
    public removedFromAbsent = new Subject<number>();

    constructor(private http: HttpClient) {}
    public setLessonAttending(lesson_id: number, data: any): Observable<any> {
        return this.http.patch<any>(`${MAIN_DOMAIN}/api/lessons/lesson/attending/${lesson_id}/`, data);
    }

    public addToAbsent(studentId: number): void {
        this.addedToAbsent.next(studentId);
    }

    public removeFromAbsent(studentId: number): void {
        this.removedFromAbsent.next(studentId);
    }
}
